import { useEffect, useState } from 'react';

// Bootstrap's `md` breakpoint - anything narrower is treated as a phone.
const SMALL_SCREEN_QUERY = '(max-width: 767.98px)';

// `.modal-body` scrolls (see App.css), so it clips anything drawn outside its box.
// On a phone the calendar fits neither above nor below the input, and its month
// and year navigation ends up cut off. These props move the calendar into a full
// screen overlay attached to <body>, clear of the modal and its clipping.
const MOBILE_PROPS = { withPortal: true, portalId: 'datepicker-portal' };
const DESKTOP_PROPS = {};

const supportsMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const propsForViewport = matches => (matches ? MOBILE_PROPS : DESKTOP_PROPS);

// Returns the DatePicker props that suit the current viewport. Spread these onto
// any <DatePicker> that lives inside a modal.
const useDatePickerPortal = () => {
    const [portalProps, setPortalProps] = useState(() =>
        propsForViewport(supportsMatchMedia() && window.matchMedia(SMALL_SCREEN_QUERY).matches)
    );

    useEffect(() => {
        if (!supportsMatchMedia()) return;

        const mediaQuery = window.matchMedia(SMALL_SCREEN_QUERY);
        const handleChange = e => setPortalProps(propsForViewport(e.matches));

        setPortalProps(propsForViewport(mediaQuery.matches));
        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return portalProps;
};

export default useDatePickerPortal;
